'use strict';

const mmWidgets = require('../../widgets/mm-widgets');

require('../../widgets/cognito-set-password-widget');
require('../../widgets/cognito-signin-widget');
require('../../widgets/cognito-change-password-widget');
require('../../widgets/context-disabler-widget');


module.exports = function cognitoWidgets(cognitoModels, authenticationModel, subscriptionModel) {
	if (!cognitoModels || !cognitoModels.cognitoApi || !cognitoModels.cognitoAuthenticator || !authenticationModel || !subscriptionModel || !cognitoModels.cognitoModel) {
		throw 'invalid-args';
	}
	mmWidgets('[data-mm-role~="cognitoSignin"]').cognitoSigninWidget(cognitoModels.cognitoApi, cognitoModels.cognitoAuthenticator);
	mmWidgets('[data-mm-role~="cognitoSetPassword"]').cognitoSetPasswordWidget(cognitoModels.cognitoApi, authenticationModel, cognitoModels.cognitoModel);
	mmWidgets('[data-mm-role~="cognitoChangePassword"]').cognitoChangePasswordWidget(cognitoModels.cognitoApi, cognitoModels.cognitoAuthenticator, authenticationModel);
	mmWidgets('[data-mm-cognito-context]').contextDisablerWidget(cognitoModels.cognitoModel, 'context', 'data-mm-cognito-context');

};
